import { ShutdownTime } from './components';
import { ItemAvatar, SideBarDialog } from 'shared/components';

import { useTurnOffProduct } from './hooks';

import makeClasses from './TurnOffProduct.style';

import type { IMenuProduct, ITurnOffItemTime } from 'features/menu-page/domain';

export function TurnOffProduct(props: Props) {
  const { product, cancelCTA, turnOffCTA } = props;
  const hasProduct = product !== null;
  if (!hasProduct) return null;

  const {
    lang,
    status,
    handleShutdownTimeOpt,
    handleShutdownCustomDate,
    handleCallToAction,
  } = useTurnOffProduct({ turnOffCTA });

  const _classes = makeClasses();

  return (
    <SideBarDialog
      size='small'
      open={hasProduct}
      onClose={cancelCTA}
      headerTitle={lang.title}
      posNav={
        <div className={_classes.info}>
          <ItemAvatar src={product.image} alt={product.name} />
          <p aria-label='info-name'>{product.name}</p>
        </div>
      }
      actions={{
        primaryBtn: {
          children: lang.action.primaryBtn,
          disabled: status.disabled,
          onClick: handleCallToAction,
        },
      }}
    >
      <ShutdownTime
        customDate={status.customDate}
        onChange={handleShutdownTimeOpt}
        onAcceptCustomDate={handleShutdownCustomDate}
      />
    </SideBarDialog>
  );
}

interface Props {
  product: IMenuProduct | null;
  cancelCTA: () => void;
  turnOffCTA: (p: ITurnOffItemTime) => void;
}
